module.exports = __webpack_public_path__ + "img/maxima_side.d211e893.png";